import {
  SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES,
  SourcingAnnotationsAction,
} from '../actions/sourcingAnnotation'

export type SourcingAnnotationCandidate = { id: number; name: string }

export type SourcingRoute = SourcingAnnotationCandidate

export type MyLabelId = number

export type MyLabel = SourcingAnnotationCandidate

export type SourcingAnnotationsCandidatesState = {
  sourcingRoutes: SourcingRoute[]
  myLabels: MyLabel[]
}

const initialState: SourcingAnnotationsCandidatesState = {
  sourcingRoutes: [],
  myLabels: [],
}

export default function sourcingAnnotationsCandidates(
  state: SourcingAnnotationsCandidatesState = initialState,
  action: SourcingAnnotationsAction
) {
  switch (action.type) {
    case SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES:
      return { ...state, ...action.payload }
  }

  return state
}
